import { Component, OnInit, Input, Output,
   EventEmitter, ElementRef, ViewChild } from '@angular/core';

import { NgForm } from "@angular/forms";
import {Router} from '@angular/router';

import { AuthService } from '../../api';
import { URLS } from '../../constants/url.constants';
import { otpDetails } from '../../interfaces';
import { SnackService } from '../../services';

@Component({
  selector: 'school-fpass-ui',
  templateUrl: './forgot-password-ui.component.html',
  styleUrls: ['./forgot-password-ui.component.scss']
})
export class FpassuiComponent implements OnInit {

  public error: string;
  isLoading: boolean;
  @Input() usertype: any;
  @Input() cancellink: any;
  @Output()
  cancelEvent = new EventEmitter<string>();

  pwdhide = true;
  confirmpwdhide = true;

  @ViewChild('inputfocus', { static: false }) inputs: ElementRef;
  @ViewChild("forgotpasswordform", { static: false }) forgotpasswordsform: NgForm;

  forgotPasswordValue = {} as otpDetails;

  current_page = 'forgot-password';

  constructor(
    private _snackService: SnackService,
    private authService: AuthService,
    private route:Router) {

    }

  ngOnInit(): void {

  }

  onSubmit(): void {
    this.error = '';
    if(this.current_page == 'forgot-password'){
      this.forgotPasswordSubmit();
    }else if(this.current_page == 'verify-forgot-password-otp'){
      this.verifyForgotPasswordSubmit();
    }
  }

  forgotPasswordSubmit() {

    if(!this.forgotPasswordValue.email){
      // this.error = "Please enter email";
      this.isLoading = false;
      this._snackService.openSnackBar("danger", "Please enter email id");
      return false;
    }

    this.forgotPasswordValue.role = this.usertype;
    const saveData = { ...this.forgotPasswordValue };
    // console.log(saveData);

    this.authService.forgotpassword(saveData).subscribe(resData => {
      // console.log(resData);
      this._snackService.openSnackBar("success", resData.body.message);
      this.current_page = 'verify-forgot-password-otp';
    },
    error => {
      this.error = error;
      this.isLoading = false;
    });
  }

  verifyForgotPasswordSubmit(){

    if(!this.forgotPasswordValue.password){
      // this.error = "Please enter email";
      this.isLoading = false;
      this._snackService.openSnackBar("danger", "Enter Password");
      return false;
    }

    if(!this.forgotPasswordValue.confirm_password){
      // this.error = "Please enter email";
      this.isLoading = false;
      this._snackService.openSnackBar("danger", "Enter Confirm Password");
      return false;
    }

    if(this.forgotPasswordValue.password != this.forgotPasswordValue.confirm_password){
      // this.error = "Please enter email";
      this.isLoading = false;
      this._snackService.openSnackBar("danger", "Password and confirm password mismatch");
      return false;
    }

    this.forgotPasswordValue.role = this.usertype;
    this.forgotPasswordValue.action = "forgotPassword";
    this.forgotPasswordValue.verify_mode = "phone";

    const saveData = { ...this.forgotPasswordValue };
    // console.log(saveData);

    this.authService.otpVerify(saveData).subscribe(resData => {
      console.log(resData,' resData');
      this._snackService.openSnackBar("success", resData.body.data.message);
      this.forgotpasswordsform.resetForm();
      this.cancel();
    },
    error => {
      this.error = error;
      this.isLoading = false;
    });
  }

  cancelForgotPassword() {
    this.cancelEvent.emit();
  }

  cancel(){
    this.route.navigate([`/${this.cancellink}`]);
  }

}
